import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { UserAvatarComponent } from './user-avatar.component';
import {MatTooltipModule} from "@angular/material/tooltip";

@NgModule({
    declarations: [UserAvatarComponent],
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        MatTooltipModule
    ],
    providers: [
    ],
    exports: [
        UserAvatarComponent,
    ],
})
export class UserAvatarModule {
}